import ISupplierInfo from "../responses/ISupplierInfo";
import Tenant from "./Tenant";

export default class Supplier {
  constructor(
    public id: number,
    public tenant: Tenant,
    public code: string,
    public name: string,
    public email: string,
    public customerCode: string,
    public info: ISupplierInfo,
  ) { }

  public get isMelodi(): boolean {
    return this.code === "MELODI";
  }
  public get receivesByDeliveryInterface(): boolean {
    return this.isMelodi;
  }
}